var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0039 0.142578C20.6576 0.142578 20.3109 0.274491 20.047 0.539077L17.7368 2.84934L23.1502 8.26288L25.4605 5.95261C25.9896 5.42344 25.9896 4.56666 25.4605 4.03884L21.9608 0.539077C21.6962 0.274491 21.3502 0.142578 21.0039 0.142578ZM15.7067 4.87942L0.143066 20.4433V25.8569H5.55652L21.1202 10.293L15.7067 4.87942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageIcon);
export default __webpack_public_path__ + "static/media/edit-image-icon.bb5e83ae80faab5bd8e501bd5a1fc3ae.svg";
export { ForwardRef as ReactComponent };